function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 24.032 24.032",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 70",
    d: "m23.707 22.293-5.969-5.969a10.016 10.016 0 1 0-1.414 1.414l5.969 5.969a1 1 0 1 0 1.414-1.414zM10 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z",
    transform: "translate(.032 .032)",
    style: {
      fill: "#0F1177"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 101"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10",
    d: "M5 4a2 2 0 1 0-2-2 2 2 0 0 0 2 2zM5 .667A1.333 1.333 0 1 1 3.667 2 1.333 1.333 0 0 1 5 .667z",
    transform: "translate(5 6)",
    style: {
      fill: "#0F1177"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11",
    d: "M3 14a3 3 0 0 0-3 3 .333.333 0 0 0 .667 0 2.333 2.333 0 0 1 4.667 0A.333.333 0 0 0 6 17a3 3 0 0 0-3-3z",
    transform: "translate(7 -3.333)",
    style: {
      fill: "#0F1177"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.77a65a099a04288841adf6e3c0c0aa43.svg";
export { ForwardRef as ReactComponent };